module.exports = __webpack_public_path__ + "static/preview-buildup-450c9dc08bd2cb7a7fcb04dd542cbbd9.png";